import type { IRecord } from '@platform/core/types';

/**
 * Порядок дочірніх записів (прототип v4: новий дочірній запис потрапляє на початок масиву записів, тож у списку він угорі): щойно
 * створені на місці (`fresh`, найновіший першим) — угорі, решта — у порядку запиту (за номером). Чиста функція.
 */
export function childOrder(items: readonly IRecord[], fresh: readonly string[]): IRecord[] {
  const rank = (r: IRecord) => { const i = fresh.indexOf(r.id); return i < 0 ? fresh.length : i; };
  return items.map((r, i) => ({ r, i })).sort((a, b) => rank(a.r) - rank(b.r) || a.i - b.i).map((x) => x.r);
}
